import React from "react";

export default function PlatformBox2({imgSrc}) {
  return (
    <div className="w-fit p-3 rounded bg-[#FFFFFF] flex justify-center items-center">
      <img src={imgSrc} alt="" className="w-full" />
    </div>
  );
}
